import { render, staticRenderFns } from "./PermanentForm.vue?vue&type=template&id=232da766&scoped=true"
import script from "./PermanentForm.vue?vue&type=script&lang=js"
export * from "./PermanentForm.vue?vue&type=script&lang=js"
import style0 from "./PermanentForm.vue?vue&type=style&index=0&id=232da766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232da766",
  null
  
)

export default component.exports